/**
 * Font callback registry - used to break circular dependency
 * between fonts.ts and pdfTextMetricsProvider.ts
 */

type FontSetCallback = (fontId: string) => void;

const fontSetCallbacks: FontSetCallback[] = [];

/**
 * Register a callback to be called when a font is set via setFont()
 */
export function registerFontSetCallback(callback: FontSetCallback): void {
  fontSetCallbacks.push(callback);
}

/**
 * Called internally when a font is set
 */
export function notifyFontSet(fontId: string): void {
  for (const callback of fontSetCallbacks) {
    callback(fontId);
  }
}
